// Main App Component - Levent Dalğın Medya Ajansı
import React from 'react';
import { Helmet } from 'react-helmet';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import References from './components/References';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Levent Dalğın Medya Ajansı | Sosyal Medya, Tasarım ve Prodüksiyon Hizmetleri</title>
        <meta 
          name="description" 
          content="Levent Dalğın Medya Ajansı; sosyal medya yönetimi, grafik ve logo tasarımı, profesyonel fotoğraf & video çekimi, drone ve açık hava reklam hizmetleri sunar." 
        />
        <meta 
          name="keywords" 
          content="medya ajansı, sosyal medya yönetimi, fotoğraf çekimi, video prodüksiyon, grafik tasarım, logo tasarımı, tanıtım filmi, Gaziantep medya ajansı, kurumsal tanıtım" 
        />
        
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Levent Dalğın Medya Ajansı | Sosyal Medya, Tasarım ve Prodüksiyon Hizmetleri" />
        <meta property="og:description" content="Levent Dalğın Medya Ajansı; sosyal medya yönetimi, grafik ve logo tasarımı, profesyonel fotoğraf & video çekimi, drone ve açık hava reklam hizmetleri sunar." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://leventdalgınmedya.com" />
        <meta property="og:image" content="https://leventdalgınmedya.com/og-image.jpg" />
        
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Levent Dalğın Medya Ajansı | Sosyal Medya, Tasarım ve Prodüksiyon Hizmetleri" />
        <meta name="twitter:description" content="Levent Dalğın Medya Ajansı; sosyal medya yönetimi, grafik ve logo tasarımı, profesyonel fotoğraf & video çekimi, drone ve açık hava reklam hizmetleri sunar." />
        <meta name="twitter:image" content="https://leventdalgınmedya.com/og-image.jpg" />
        
        {/* Structured Data - Organization Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Levent Dalğın Medya Ajansı",
            "description": "Sosyal medya yönetimi, grafik tasarım, fotoğraf ve video çekimi, drone çekimi ve açık hava reklam hizmetleri sunan medya ajansı",
            "url": "https://leventdalgınmedya.com",
            "logo": "https://leventdalgınmedya.com/logo.png",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+90-5xx-xxx-xx-xx",
              "contactType": "customer service",
              "email": "info@leventdalgınmedya.com"
            },
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Gaziantep",
              "addressCountry": "TR"
            },
            "sameAs": [
              "https://instagram.com/leventdalgınmedya",
              "https://youtube.com/@leventdalgınmedya",
              "https://linkedin.com/company/leventdalgınmedya"
            ],
            "service": [
              "Sosyal Medya Yönetimi",
              "Logo Tasarımı",
              "Grafik Tasarım",
              "Fotoğraf ve Video Çekimi",
              "Drone Çekimi",
              "Halı Fotoğraf & Video Çekimi",
              "Açık Hava Reklamları",
              "Tanıtım Filmi"
            ]
          })}
        </script>
      </Helmet>

      {/* Main Content */}
      <Header />
      <Hero />
      <Services />
      <References />
      <Contact />
    </div>
  );
}

export default App;